import React, { useState } from "react";
import moment from "moment";
import { InputField } from "../../../../../components/controls/InputField";
import { DatePickerControl, SelectListControl } from "../../../../../components/controls";
import ButtonControl from "../../../../../components/controls/ButtonControl";

const DATE_FORMAT = "YYYY-MM-DD";
const MAX_RANGE_YEARS = 2;

const PRESETS = [
  { text: "Last 45 days", value: "45" },
  { text: "Last 90 days", value: "90" },
  { text: "Last year", value: "365" },
  { text: "Last 2 years", value: "730" },
  { text: "Custom Range", value: "custom" },
];

export const DEFAULT_PRESET = "45";

function rangeForPreset(preset) {
  const endDate = moment().utc();
  const startDate = moment().utc().subtract(Number(preset), "days");
  return {
    startDate: startDate.format(DATE_FORMAT),
    endDate: endDate.format(DATE_FORMAT),
  };
}

// Clamps a date string to within [min, max] (inclusive). Guards against
// values outside the allowed range getting into state at all - e.g. from a
// typed/pasted value - rather than relying solely on the <input> min/max
// attributes, which only mark the field invalid without blocking entry.
function clampDate(dateStr, min, max) {
  if (!dateStr) return dateStr;
  const date = moment.utc(dateStr, DATE_FORMAT, true);
  if (!date.isValid()) return dateStr;
  if (date.isBefore(moment.utc(min, DATE_FORMAT))) return min;
  if (date.isAfter(moment.utc(max, DATE_FORMAT))) return max;
  return dateStr;
}

export default function VirtualLibrarianChatLogFilter({ onApply, loading }) {
  const [preset, setPreset] = useState(DEFAULT_PRESET);
  const [customStartDate, setCustomStartDate] = useState(
    moment().utc().subtract(Number(DEFAULT_PRESET), "days").format(DATE_FORMAT)
  );
  const [customEndDate, setCustomEndDate] = useState(
    moment().utc().format(DATE_FORMAT)
  );

  const maxDate = moment().utc().format(DATE_FORMAT);
  const minDate = moment().utc().subtract(MAX_RANGE_YEARS, "years").format(DATE_FORMAT);

  const handlePresetChange = (value) => {
    setPreset(value);
  };

  const handleCustomStartDateChange = (value) => {
    setCustomStartDate(clampDate(value, minDate, customEndDate || maxDate));
  };

  const handleCustomEndDateChange = (value) => {
    setCustomEndDate(clampDate(value, customStartDate || minDate, maxDate));
  };

  const handleApply = () => {
    if (preset === "custom") {
      onApply(customStartDate, customEndDate);
    } else {
      const { startDate, endDate } = rangeForPreset(preset);
      onApply(startDate, endDate);
    }
  };

  return (
    <div className="vl-history-filter">
      <div className="filterControl">
        <InputField
          id="preset"
          title="Date Range"
          fieldName="preset"
          value={preset}
          disableError={true}
          groupId={"VL_ADMIN_REVIEW"}
          onChange={handlePresetChange}
        >
          <SelectListControl hidePleaseSelect={true} textValuePairs={PRESETS} />
        </InputField>
      </div>
      {preset === "custom" && (
        <div className="date-range-group">
          <div className="filterControl">
            <InputField
              id="customStartDate"
              title="Start Date"
              value={customStartDate}
              fieldName="customStartDate"
              disableError={true}
              groupId={"VL_ADMIN_REVIEW"}
              onChange={handleCustomStartDateChange}
            >
              <DatePickerControl
                includeTime={false}
                minDate={minDate}
                maxDate={customEndDate || maxDate}
              />
            </InputField>
          </div>
          <div className="filterControl">
            <InputField
              id="customEndDate"
              title="End Date"
              value={customEndDate}
              fieldName="customEndDate"
              disableError={true}
              groupId={"VL_ADMIN_REVIEW"}
              onChange={handleCustomEndDateChange}
            >
              <DatePickerControl
                includeTime={false}
                minDate={customStartDate || minDate}
                maxDate={maxDate}
              />
            </InputField>
          </div>
        </div>
      )}
      <div className="filterControl btn-apply">
        <ButtonControl onClick={handleApply} loading={loading}>
          Apply
        </ButtonControl>
      </div>
    </div>
  );
}
